import { CompilationContext } from '../declarations/compilation';
import { ContentParameters } from '../declarations/content';
import { ConstraintPattern, ContentType } from '../declarations/enums';


export class TemplateTrackingUtils {

  static contentTypeAbbreviations = {
    [ContentType.Button]: 'b',
    [ContentType.Image]: 'i',
    [ContentType.Text]: 'd',
    [ContentType.Title]: 't'
  };

  static setCustomTrackingParameter(a_tag: HTMLAnchorElement, context: CompilationContext, params: ContentParameters, isArticle: boolean, articleIndex?: number): void {
    if (context.constraints?.find(constraint => constraint.pattern === ConstraintPattern.CustomTracking && constraint.active)) {
      let customTrackingValue: string;
      let customTrackingIndex: number = 0;
      if (params.customTracking) {
        customTrackingValue = params.customTracking;
      } else if (isArticle) {
        customTrackingIndex = articleIndex + 1;
        customTrackingValue = `article ${customTrackingIndex}`;
      }
      if (customTrackingValue) {
        // Version générique (Selligent et probablement d'autres) : data-link="article 1", data-link="article 2", etc.
        a_tag.setAttribute('data-link', customTrackingValue);
        // Version spécifique Actito :
        // * data-actito-link-business-key="1", data-actito-link-business-key="2", etc.
        // * data-actito-link-name="article 1", data-actito-link-name="article 2", etc.
        a_tag.setAttribute('data-actito-link-business-key', String(customTrackingIndex));
        a_tag.setAttribute('data-actito-link-name', customTrackingValue);
      }
    }
  }

  static getMediegoTrackingParameter(context: CompilationContext, params: ContentParameters, contentType: ContentType, isArticle: boolean, articleIndex?: number): string {
    if (context.constraints?.find(constraint => constraint.pattern === ConstraintPattern.HeatmapUTM && constraint.active)) {
      let mgo_hValue;
      if (params.customTracking) {
        mgo_hValue = params.customTracking;
      } else if (isArticle) {
        mgo_hValue = `${articleIndex + 1}${TemplateTrackingUtils.contentTypeAbbreviations[contentType]}`;
      }
      if (!!mgo_hValue) {
        return `&mgo_h=${mgo_hValue}`;
      }
    }
    return '';
  }
}
